import { getConfig } from '../../utils/config';

console.log("ENV : ** ", getConfig('REACT_APP_NODE_ENV'), "env ")

export const localDatabaseUrls = {
   baseURL: `${getConfig('REACT_APP_NODE_ENV') === "dev" ? "http://localhost:8181" : window.location.origin}/costmanagement/`,
  //  baseURL: 'http://localhost:8181/costmanagement/',
  serviceURL: {

    // cost upload
    costUpload:'api/v1/upload-cost-file',
    costUploadHistory:'api/v1/cost-upload-history',
    manageUsers:'api/v1/manage-users',
    errorReportFile:'api/v1/cost-file/',
    errorReportFilePrefix:'errorReport',
    downloadTemplateFile:'api/v1/cost-file/template',
    originalFilePrefix:'originalFile',

    // cjw upload
    cjwUploadFile:'api/v1/upload-cjw-file',
    cjwUploadHistory:'api/v1/cjw-upload-history',
    cjwFilterHistory:'api/v1/cjw-file/upload-history',
    cjwDownloadFile:'api/v1/cjw-file/{fileID}/{downloadFile}',
    cjwDeleteFile:'api/v1/cjw-file/delete/',
    cjwDownloadTemplate:'api/v1/cjw-file/template',
    cjwDownload: 'api/v1/cjw-file/',
    obsoleteString: "obsoleteFile",
    processString: "processedFile",
    costFilePrefix: 'costFile',
    draftToApprove: 'api/v1/cjw-file/toBeApproved/',

    // cjw-di upload (Direct Import)
    cjwDiUploadFile:'api/v1/upload-cjw-di-file',
    cjwDiUploadHistory:'api/v1/cjw-di-upload-history',
    cjwDiDownload: 'api/v1/cjw-di-file/',
    cjwDiDraftToApprove: 'api/v1/cjw-di-file/toBeApproved/',
    cjwDiDeleteFile: 'api/v1/cjw-di-file/delete/',
    purchaseCostFilePrefix: 'purchasecost',


    // svc upload
    svcUploadFile: 'api/v1/upload-svc-file',
    svcDuplicateFileNameCheck: 'api/v1/svc-file/check-duplicate-svc?filename=xyz',
    svcUploadHistory: 'api/v1/svc-file/history',
    svcDownload: 'api/v1/svc-file/',
    svcDownloadTemplate: 'api/v1/svc-file/template',
    originalFilePrefixSvc: 'originalFileSvc',
    errorFileSvc: 'errorFileSvc',

    //Landed Cost Uploads
    landedCostUploadBase: "api/v1/upload/",
    landedCostUploadHistory: "api/v1/landed-cost/vendor-file/history",
    landedCostRunDetailsUpload: "api/v1/landed-cost/run-details-file",
    landedCostRunDetailsTemplate: "api/v1/landed-cost/run-details/template",
    landedCostRunDetailsUpdate: "api/v1/landed-cost/run-details/update",
    landedCostDownloadFile: "api/v1/landed-cost/file/",
    landedCostDownloadTemplate: "api/v1/landedcost/template/",
    landedVendorOriginalFilePrefix: "landedVendorOriginal",
    landedVendorErrorFilePrefix: "landedVendorError",
    landedCostUploadHistoryDelete: "api/v1/landed-cost/vendor-file/history/delete",
    landedCostUploadHistoryUpdate: "api/v1/landed-cost/vendor-file/history/update",
    landedCostAntiDumpingHistory: "api/v1/landed-cost/anti-dumping/history",
    landedCostAntiDumpingHistoryUpdate: "api/v1/landed-cost/anti-dumping/history/update",
    landedCostSkuExclusionHistory: "api/v1/landed-cost/sku-exclusion/history",
    landedCostSkuExclusionHistoryUpdate: "api/v1/landed-cost/sku-exclusion/history/update",
    landedCostTariffHistory: "api/v1/landed-cost/tariff-rates/history",
    landedCostTariffHistoryUpdate: "api/v1/landed-cost/tariff/history/update",
    landedCostContainerRateHistory: "api/v1/landed-cost/container-rates/history",
    landedCostContainerRateHistoryUpdate: "api/v1/landed-cost/container-rate/history/update",
    landedCostCalculationUpload: "api/v1/landed-cost/calculation/upload",
    landedCostCalculationWorkflow: "api/v1/landed-cost/calculation/workflow",
    landedCostUpdate: "api/v1/landed-cost-update",
    landedCostDataViewGenerate: "api/v1/landed-cost/data-view",
    landedCostDataViewExportCsv: "api/v1/landed-cost/data-view/export-csv",
    landedCostDataViewHistory: "api/v1/landed-cost/history-view",
    runDetailsBatchJob: "api/v1/run-details/batchJob",
    runDetailsHistory: "api/v1/run-details/history",
    // rules
    ruleLogs: "api/v1/rules/logs",
    ruleUpdate: "api/v1/rules/update",
    landingRuleLogs: "api/v1/rules/flag/Landing",
    prioritizationRuleLogs: "api/v1/prioritization/rules/history",
    prioritizationRuleUpdate: "api/v1/prioritization/rules/update",
    activeRuleFlag: "api/v1/rules/active/flag",

    // margin strategy rules
    marginStrategySkuStrategies: "api/v1/marginstrategy/rules/sku-strategies/paginated",
    marginStrategyUpdate: "api/v1/marginstrategy/rules/update",
    marginStrategyAutocomplete: "api/v1/marginstrategy/rules/autocomplete",
    marginStrategyUpload: "api/v1/margin-strategy/upload",
    skuSinglePrice: "api/v1/sku-single-price",
    skuSinglePriceUpload: "api/v1/sku-single-price/upload",

    // dc cost
    dcCostMain: "api/v1/dc-cost/main",
    dcCostLinked: "api/v1/dc-cost/linked",
    dcCostColor: "api/v1/dc-cost/color",
    dcCostItems: "api/v1/dc-cost-sku/batch",
    dcCostItemsUpdate: "api/v1/dc-cost/items/update",
    dcCostManualPullUpload: "api/v1/dc-cost-manual-pull/upload",
    dcCostManualPullUserUploads: "api/v1/dc-cost-manual-pull/user-uploads",
    skuStatusUpdate: "api/v1/sku-status/update",
    skuStatusRestore: "api/v1/sku-status/restore",
    notifications: "api/v1/notifications",
    notificationsRead: "api/v1/notifications/{notificationId}/read",
    notificationsReadAll: "api/v1/notifications/read-all",

   
  },
  



};

export default localDatabaseUrls;
